import { useAppTranslation } from "src/i18n/hooks";
import { Button } from "../ui/button";
import { useAppSelector } from "src/store";
import { THEME_MODE } from "src/interfaces/theme";
import { ChangeEvent } from "react";

interface Props {
  value: string;
  disabledMaxButton?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onMaxClick?: () => void;
  availableAmount: string;
  tokenTicker: string;
}

const AmountInput = (props: Props) => {
  const { value, disabledMaxButton, onMaxClick, availableAmount, onChange, tokenTicker } = props;
  const { t } = useAppTranslation('trade');
  const userTheme = useAppSelector((state) => state.theme);

  return (
    <div className="rounded-[10px] py-4 px-3 bg-white dark:bg-gray-800 border hover:border-blue-300 focus:border-blue-500 transition-colors">
      <div className="flex gap-1 items-center h-full">
        <span className={`text-sm ${userTheme === THEME_MODE.DARK ? 'text-white' : 'text-gray-600'}`}>{t('amount')}</span>
        <input onKeyDown={(e) => {
          if (e.key === '-' || e.key === 'e') {
            e.preventDefault();
          }
        }}
          value={value} onChange={onChange}
          className="amount-input outline-none flex-1 border-none focus:border-none text-right" type="text" />
        <Button
          onClick={onMaxClick}
          type="button"
          variant="ghost"
          size="sm"
          disabled={disabledMaxButton}
          className="h-6 px-2 text-blue-600 hover:text-blue-700 hover:bg-blue-50 text-xs"
        >
          {t('withdrawModal.max')}
        </Button>
      </div>
      <div className="divider my-2 w-full h-[1px] bg-[#d0d5dc] dark:bg-[#424850]" />
      <div className="flex justify-between items-center">
        <span>Available</span>
        <span>{availableAmount} {tokenTicker}</span>
      </div>
    </div>
  );
};

export default AmountInput;